import React, { createContext, useCallback, useContext } from "react";
import dayjs from "../../../utils/dayjs";
const PriceCalendarContext = createContext(null);
PriceCalendarContext.displayName = "PriceCalendarContext";
const PriceCalendarProvider = ({
  prices,
  isLoading,
  children
}) => {
  const getPriceData = useCallback((date) => {
    const priceData = prices == null ? void 0 : prices[date];
    if (priceData) {
      return { ...priceData, isLoading };
    }
    const isInPast = dayjs(date).isBefore(dayjs(), "day");
    return { priceString: "", isLoading, isEmpty: isInPast };
  }, [prices, isLoading]);
  return /* @__PURE__ */ React.createElement(PriceCalendarContext.Provider, {
    value: { prices, isLoading, getPriceData }
  }, children);
};
const usePriceCalendarContext = () => {
  const context = useContext(PriceCalendarContext);
  if (context === null)
    throw new Error(`Attempted to call usePriceCalendarContext() before wrapping it around an PriceCalendarProvider.`);
  return context;
};
var PriceCalendarContext_default = PriceCalendarProvider;
export {
  PriceCalendarProvider,
  PriceCalendarContext_default as default,
  usePriceCalendarContext
};
